export enum ConstructionStatusEnum {
	UnderConstruction = "underConstruction",
	ReadyToMoveIn = "readyToMoveIn",
}

export const constructionStatus = [
	{
		value: "underConstruction",
		label: "Under Construction",
		options: [
			{ value: "preLaunch", label: "Pre Launch", shortLabel: "Prelao" },
			{ value: "max:4", label: "< 4yrs", shortLabel: "< 4Y" },
			{ value: "max:3", label: "< 3yrs", shortLabel: "< 3Y" },
			{ value: "max:2", label: "< 2yrs", shortLabel: "< 2Y" },
			{ value: "max:1", label: "< 1yrs", shortLabel: "< 1Y" },
			{ value: "max:0.5", label: "< 6 months", shortLabel: "< 6M" },
		],
	},
	{
		value: "readyToMoveIn",
		label: "Ready To Move In",
		options: [
			{ value: "max:1", label: "< 1yrs", shortLabel: "< 1Y" },
			{ value: "max:2", label: "< 2yrs", shortLabel: "< 2Y" },
			{ value: "max:4", label: "< 4yrs", shortLabel: "< 4Y" },
			{ value: "max:7", label: "< 7yrs", shortLabel: "< 7Y" },
			{ value: "max:10", label: "< 10yrs", shortLabel: "< 10Y" },
			{ value: "max:15", label: "< 15yrs", shortLabel: "< 15Y" },
		],
	},
];
